import React from "react";
import { Box, Group, Text, useMantineTheme, Avatar } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";

import { safeValue, CustomerCategoryIcon } from "../../utils/globalFunctions";
import { canAccessSeeCustomersPhoneNumber } from "../../utils/accessing";

import PaperWrapper from "../../components/utilities/PaperWrapper";

const ComponentCustomer = ({ stateData }) => {

    const theme = useMantineTheme();
    const { loginContext } = useLoginContext();

    return (
        <PaperWrapper stateMB="2rem">
            <Group align='flex-start'>
                <Avatar
                    radius="xl"
                >
                    <CustomerCategoryIcon
                        stateCustomerCategory={stateData.customer_category_slug}
                        stateSize='1.5rem'
                        stateColor={theme.colorScheme === 'light' ? '#000' : '#fff'}
                    />
                </Avatar>

                <Box>
                    <Text size="sm" fw={500}>
                        {stateData.customer_name}
                    </Text>

                    <Text size="xs">
                        {stateData.customer_category_name}
                    </Text>

                    {canAccessSeeCustomersPhoneNumber({ stateObject: { subLevel: loginContext } }) &&
                        <Text size="xs">
                            {safeValue(stateData.customer_contact, '[Kontak]')}
                        </Text>
                    }
                </Box>
            </Group>
        </PaperWrapper>
    )
}

export default ComponentCustomer;